import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import { io } from 'socket.io-client';
import { useEffect, useState } from 'react';
import ByteBuddies from './components/bytebuddies';
import { ByteBuddiesSocket } from './types';
import StoreProvider from './StoreProvider';

const container = document.getElementById('root');

const App = () => {
  const [socket, setSocket] = useState<ByteBuddiesSocket | null>(null);

  const serverURL = process.env.REACT_APP_SERVER_URL;

  if (serverURL === undefined) {
    throw new Error("Environment variable 'REACT_APP_SERVER_URL' must be defined");
  }

  useEffect(() => {
    if (!socket) {
      setSocket(io(serverURL));
    }

    return () => {
      if (socket !== null) {
        socket.disconnect();
      }
    };
  }, [socket, serverURL]);

  return (
    <Router>
      <ByteBuddies socket={socket} />
    </Router>
  );
};

if (container) {
  const root = ReactDOM.createRoot(container);
  // Wrap `App` with `StoreProvider` to ensure Redux context is available
  root.render(
    <StoreProvider>
      <App />
    </StoreProvider>,
  );
}
